import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;

  justify-self: center;
  margin: 5% auto;
  padding: 10px;
  width: 40%;
  border-radius: 8px;
  background: #fff;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  section {
    width: 98%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    margin: 16px 0;
    h1 {
      font-size: 22px;
    }
    p {
      font-size: 0.85rem;
    }
    .add {
      display: flex;
      align-items: center;
      justify-content: center;
      .link {
        font-size: 14px;
      }
    }
  }
`;
